import React, { useState } from 'react';
import Home from './Home';
import Banks from './Banks';
import Deposits from './Deposits';
import Stocks from './Stocks';
import MutualFunds from './MutualFunds';

export enum PORTFOLIOPAGES {
  HOME,
  MUTUAL_FUNDS,
  STOCKS,
  BANKS,
  DEPOSITS,
}
const Portfolio: React.FC<{ onBack: () => void; type: string }> = ({
  onBack,
  type,
}) => {
  const [portfolioCurrentPage, setPortfolioCurrentPage] = useState(
    type === 'MUTUAL_FUNDS'
      ? PORTFOLIOPAGES.MUTUAL_FUNDS
      : type === 'DEPOSITS'
      ? PORTFOLIOPAGES.DEPOSITS
      : PORTFOLIOPAGES.STOCKS
  );
  const renderPortfolioPage = () => {
    switch (portfolioCurrentPage) {
      case PORTFOLIOPAGES.HOME:
        return <Home />;
      case PORTFOLIOPAGES.BANKS:
        return <Banks />;
      case PORTFOLIOPAGES.MUTUAL_FUNDS:
        return <MutualFunds onBack={onBack} />;
      case PORTFOLIOPAGES.DEPOSITS:
        return <Deposits onBack={onBack} />;
      case PORTFOLIOPAGES.STOCKS:
        return <Stocks onBack={onBack} />;
    }
  };
  return <>{renderPortfolioPage()}</>;
};

export default Portfolio;
